import React from 'react';
import styled from 'styled-components';
import { TARGET_NETWORK } from '../config/network';

const BannerContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  padding: 1rem;
  background: linear-gradient(
    90deg,
    rgba(20, 20, 20, 0.95) 0%,
    rgba(20, 20, 20, 0.98) 100%
  );
  border-bottom: 2px solid rgba(255, 193, 7, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  z-index: 1000;
  backdrop-filter: blur(10px);
`;

const InfoText = styled.div`
  color: ${({ theme }) => theme.colors.text};
  font-size: 1rem;
  line-height: 1.5;
  text-align: center;
  margin-right: 1rem;
`;

const NetworkName = styled.span`
  color: #ffc107;
  font-weight: 600;
`;

const SwitchButton = styled.button`
  background: rgba(255, 193, 7, 0.9);
  color: #000;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  font-size: 1rem;
  box-shadow: 0 2px 8px rgba(255, 193, 7, 0.2);

  &:hover:not(:disabled) {
    background: rgba(255, 193, 7, 1);
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(255, 193, 7, 0.3);
  }

  &:active:not(:disabled) {
    transform: translateY(0);
    box-shadow: 0 2px 4px rgba(255, 193, 7, 0.2);
  }

  &:disabled {
    cursor: not-allowed;
    background: rgba(255, 193, 7, 0.5);
  }
`;

interface NetworkSwitchBannerProps {
  onSwitchNetwork: () => Promise<boolean>;
}

export const NetworkSwitchBanner: React.FC<NetworkSwitchBannerProps> = ({
  onSwitchNetwork,
}) => {
  const [isLoading, setIsLoading] = React.useState(false);

  const handleSwitchNetwork = async () => {
    try {
      setIsLoading(true);
      const success = await onSwitchNetwork();
      if (!success) {
        console.warn('Failed to switch network');
      }
    } catch (error) {
      console.error('Error switching network:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <BannerContainer>
      <InfoText>
        Please switch to <NetworkName>{TARGET_NETWORK.chainName}</NetworkName> to participate in the lottery. 
        Your current network is not supported.
      </InfoText>
      <SwitchButton 
        onClick={handleSwitchNetwork} 
        disabled={isLoading}
        style={{ opacity: isLoading ? 0.7 : 1 }}
      >
        {isLoading ? 'Switching...' : 'Switch Network'}
      </SwitchButton>
    </BannerContainer>
  );
};
